export default "__VITE_ASSET__GZSHqmlo__"